(function() {
  const sectionState = new WeakMap();

  function waitForImages(container) {
    const images = Array.from(container.querySelectorAll('img'));
    const unsettled = images.filter(img => !img.complete || img.naturalWidth === 0);
    if (unsettled.length === 0) return Promise.resolve();
    return Promise.all(unsettled.map(img => new Promise(resolve => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    })));
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function cloneNodes(nodes) {
    return nodes.map(n => n.cloneNode(true));
  }

  function appendAll(parent, nodes) {
    const frag = document.createDocumentFragment();
    nodes.forEach(n => frag.appendChild(n));
    parent.appendChild(frag);
  }

  function buildSeamless(track, viewport, baseNodes) {
    clearChildren(track);
    // Baue eine Sequenz B, die mindestens die Viewport-Breite abdeckt
    let sequence = cloneNodes(baseNodes);
    appendAll(track, cloneNodes(sequence));
    while (track.scrollWidth < viewport.clientWidth && baseNodes.length > 0) {
      const extra = cloneNodes(baseNodes);
      appendAll(track, extra);
      sequence = sequence.concat(extra);
    }
    // Distanz = Breite von B
    const distance = track.scrollWidth;
    // Dupliziere B zu B|B
    appendAll(track, cloneNodes(Array.from(track.children)));
    track.style.setProperty('--marquee-distance', distance + 'px');
  }

  function pause(track) {
    track.style.animationPlayState = 'paused';
  }

  function resume(track) {
    if (!track.classList.contains('is-animating')) {
      track.classList.add('is-animating');
    }
    track.style.animationPlayState = 'running';
  }

  function initSection(section) {
    if (!section) return;
    const viewport = section.querySelector('.logo-slider__viewport');
    const track = section.querySelector('.logo-slider__track');
    if (!viewport || !track) return;

    const autoscroll = viewport.getAttribute('data-autoscroll') === 'true';
    const pauseOnHover = viewport.getAttribute('data-pause-hover') === 'true';
    const respectReduced = viewport.getAttribute('data-reduced-motion') === 'true';
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let state = sectionState.get(section);
    if (!state) {
      state = { baseNodes: null, resizeBound: false, io: null, visHandlerBound: false };
      sectionState.set(section, state);
    }

    // Entferne evtl. vorherige Animation vor Neuaufbau
    track.classList.remove('is-animating');

    if (!autoscroll || (respectReduced && prefersReduced)) return;

    const setup = () => {
      if (!state.baseNodes) {
        // Snapshot der ursprünglichen Slides sichern
        const originals = Array.from(track.children);
        state.baseNodes = originals.map(n => n.cloneNode(true));
      }
      buildSeamless(track, viewport, state.baseNodes);
      resume(track);
    };

    // Beim ersten Mal warten wir auf die Bilder der ursprünglichen Struktur
    if (!state.baseNodes) {
      waitForImages(track).then(setup);
    } else {
      setup();
    }

    if (pauseOnHover && !state.hoverBound) {
      state.hoverBound = true;
      viewport.addEventListener('mouseenter', function() { pause(track); });
      viewport.addEventListener('mouseleave', function() { resume(track); });
    }

    if (!state.io) {
      state.io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            resume(track);
          } else {
            pause(track);
          }
        });
      }, { threshold: 0.01 });
      state.io.observe(viewport);
    }

    if (!state.visHandlerBound) {
      state.visHandlerBound = true;
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          pause(track);
        } else {
          resume(track);
        }
      });
    }

    if (!state.resizeBound) {
      state.resizeBound = true;
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          // Rebuild mit Basisschnappschuss
          buildSeamless(track, viewport, state.baseNodes || Array.from(track.children));
          resume(track);
        }, 150);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.logo-slider').forEach(function(section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    const s = e.target && e.target.querySelector ? e.target.querySelector('.logo-slider') : null;
    if (s) initSection(s);
  });
})();
